/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesVersusCostReportsByDayRollup } from './SalesVersusCostReportsByDayRollup';
import {
    SalesVersusCostReportsByDayRollupFromJSON,
    SalesVersusCostReportsByDayRollupFromJSONTyped,
    SalesVersusCostReportsByDayRollupToJSON,
    SalesVersusCostReportsByDayRollupToJSONTyped,
} from './SalesVersusCostReportsByDayRollup';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ReportSalesVersusCosts } from './ReportSalesVersusCosts';
import {
    ReportSalesVersusCostsFromJSON,
    ReportSalesVersusCostsFromJSONTyped,
    ReportSalesVersusCostsToJSON,
    ReportSalesVersusCostsToJSONTyped,
} from './ReportSalesVersusCosts';

/**
 * 
 * @export
 * @interface ListSalesVersusCostReportsByDayResponse
 */
export interface ListSalesVersusCostReportsByDayResponse {
    /**
     * 
     * @type {Array<ReportSalesVersusCosts>}
     * @memberof ListSalesVersusCostReportsByDayResponse
     */
    data: Array<ReportSalesVersusCosts>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListSalesVersusCostReportsByDayResponse
     */
    pagination: Pagination;
    /**
     * 
     * @type {SalesVersusCostReportsByDayRollup}
     * @memberof ListSalesVersusCostReportsByDayResponse
     */
    rollup: SalesVersusCostReportsByDayRollup;
}

/**
 * Check if a given object implements the ListSalesVersusCostReportsByDayResponse interface.
 */
export function instanceOfListSalesVersusCostReportsByDayResponse(value: object): value is ListSalesVersusCostReportsByDayResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('rollup' in value) || value['rollup'] === undefined) return false;
    return true;
}

export function ListSalesVersusCostReportsByDayResponseFromJSON(json: any): ListSalesVersusCostReportsByDayResponse {
    return ListSalesVersusCostReportsByDayResponseFromJSONTyped(json, false);
}

export function ListSalesVersusCostReportsByDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSalesVersusCostReportsByDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReportSalesVersusCostsFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
        'rollup': SalesVersusCostReportsByDayRollupFromJSON(json['rollup']),
    };
}

  export function ListSalesVersusCostReportsByDayResponseToJSON(json: any): ListSalesVersusCostReportsByDayResponse {
      return ListSalesVersusCostReportsByDayResponseToJSONTyped(json, false);
  }

  export function ListSalesVersusCostReportsByDayResponseToJSONTyped(value?: ListSalesVersusCostReportsByDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ReportSalesVersusCostsToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
        'rollup': SalesVersusCostReportsByDayRollupToJSON(value['rollup']),
    };
}

